import React from "react";
import { DialogActions } from "@mui/material";

export default function NewDialogActions({ isPopup = true, children }) {
  const sx = !isPopup
    ? {
        m: 0,
        p: 1,
        right: 0,
        zIndex: 1,
        // height: 72,
        height: 48,
        position: 'fixed',
        left: { xs: 0, lg: 320 },
        bottom: { xs: 72, sm: 0 },
        bgcolor: 'background.paper',
        borderRadius: '8px 8px 0 0',
      }
    : { px: 1, pt: 1, pb: 2 };

  return <DialogActions sx={sx}>{children}</DialogActions>;
}
